var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329.27 430.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-dasharray: 0 0 0 0 0 0 0 0 0 0 0 0;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #4e6283;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feeder"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bg",
    className: "cls-2",
    points: "57.42 5.14 270.9 5.14 271.7 320.36 172.54 377.29 154.3 377.29 56.73 318.98 57.42 5.14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fills"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "129.02 21.53 129.02 199.17 96.72 231.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "96.1 231.92 96.31 225.92 97.31 225.95 97.13 230.88 102.06 230.7 102.1 231.7 96.1 231.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "239.54 21.53 239.54 302.48 182.86 336.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "183.58 331.64 184.54 331.91 183.19 336.66 188.02 337.65 187.82 338.63 181.94 337.42 183.58 331.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 202.46,
    y1: 269.03,
    x2: 202.46,
    y2: 21.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "206.55 265.72 205.82 265.04 202.46 268.65 199.11 265.04 198.37 265.72 202.46 270.12 206.55 265.72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "194.65 21.53 194.65 198.81 227 231.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "221.76 231.7 221.8 230.7 226.73 230.88 226.55 225.95 227.55 225.92 227.76 231.92 221.76 231.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 119.52,
    y1: 269.03,
    x2: 119.52,
    y2: 21.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "123.61 265.72 122.88 265.04 119.52 268.65 116.16 265.04 115.43 265.72 119.52 270.12 123.61 265.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "83.93 21.53 83.93 302.48 140.6 336.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "135.64 338.63 135.44 337.65 140.27 336.66 138.92 331.91 139.89 331.64 141.52 337.42 135.64 338.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 119.52,
    y1: 269.03,
    x2: 119.52,
    y2: 21.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "123.61 265.72 122.88 265.04 119.52 268.65 116.16 265.04 115.43 265.72 119.52 270.12 123.61 265.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "239.54 21.53 239.54 302.48 182.86 336.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "183.58 331.64 184.54 331.91 183.19 336.66 188.02 337.65 187.82 338.63 181.94 337.42 183.58 331.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "83.93 21.53 83.93 302.48 140.6 336.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "135.64 338.63 135.44 337.65 140.27 336.66 138.92 331.91 139.89 331.64 141.52 337.42 135.64 338.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 202.46,
    y1: 269.03,
    x2: 202.46,
    y2: 21.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "206.55 265.72 205.82 265.04 202.46 268.65 199.11 265.04 198.37 265.72 202.46 270.12 206.55 265.72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gravity"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "129.02 21.53 129.02 199.17 96.72 231.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "96.1 231.92 96.31 225.92 97.31 225.95 97.13 230.88 102.06 230.7 102.1 231.7 96.1 231.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "194.65 21.53 194.65 198.81 227 231.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "221.76 231.7 221.8 230.7 226.73 230.88 226.55 225.95 227.55 225.92 227.76 231.92 221.76 231.7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m272.4,377.62H56.46V3.98h215.94v373.64h0Zm-214.71-1.23h213.48V5.2H57.69v371.18h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 163.82,
    y: 4.59,
    width: 1.23,
    height: 207.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m329.27,319.95h-58.09v-66.53l58.09,31.91v34.62Zm-56.86-1.23h55.63v-32.66l-55.63-30.56v63.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,285.33l58.09-31.91v66.53H0v-34.62Zm56.86,33.39h0v-63.22S1.23,286.06,1.23,286.06v32.66s55.63,0,55.63,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "276.81 8.56 275.58 8.56 275.58 1.23 54.16 1.23 54.16 8.56 52.93 8.56 52.93 0 276.81 0 276.81 8.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m177.73,387.23h-28.46v-10.84h28.46v10.84Zm-27.23-1.23h26v-8.38h-26v8.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "171.1 383.36 156.3 383.36 153.46 377.26 154.58 376.74 157.08 382.13 170.31 382.13 172.82 376.74 173.93 377.26 171.1 383.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87.81,
    y: 377,
    width: 3.74,
    height: 18.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 236.24,
    y: 377,
    width: 3.74,
    height: 18.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 72.86,
    y: 394.95,
    width: 183.14,
    height: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m77.65,377v26.7c0,2.4,1.33,1.87,4.27,1.87s31.1.08,38.9.27c10.98.27,16.13,11.21,16.13,16.82,0,2.41.95,2.66,2.8,2.66h5.34v-5.07h-3.74s-2.85-17.81-20.47-18.81c-8.47-.48-15.2-.28-23.74-.28h-13.88c-.8,0-1.33-1.47-1.33-3.34v-20.82h-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m166.71,391.9h-6.97v-5.9h6.97v5.9Zm-5.74-1.23h4.51v-3.44h-4.51v3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m168.18,396.04h-9.91v-3.9h9.91v3.9Zm-8.68-1.23h7.45v-1.44h-7.45v1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m156.04,396.04h-3.9v-3.9h3.9v3.9Zm-2.67-1.23h1.44v-1.44h-1.44v1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m174.86,396.04h-3.9v-3.9h3.9v3.9Zm-2.67-1.23h1.44v-1.44h-1.44v1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m182.87,430.74h-38.34v-35.94h38.34v35.94Zm-37.11-1.23h35.88v-33.48h-35.88v33.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 151.23,
    y: 395.42,
    width: 24.84,
    height: 27.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "173.68 377.53 173.06 376.47 271.47 319.42 272.09 320.48 173.68 377.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 104.75,
    y: 291.31,
    width: 1.23,
    height: 113.33,
    transform: "translate(-247.46 260.24) rotate(-59.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m164.44,215.69c-1.14,0-2.07-.93-2.07-2.07s.93-2.07,2.07-2.07,2.07.93,2.07,2.07-.93,2.07-2.07,2.07Zm0-2.91c-.46,0-.84.38-.84.84s.38.84.84.84.84-.38.84-.84-.38-.84-.84-.84Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModes);
export default __webpack_public_path__ + "static/media/modes.c81fa82ac76755475d3a8a0206fcddc8.svg";
export { ForwardRef as ReactComponent };